import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'

import { clearSeriesTab, requestSeriesTab } from '../seriesTabIntent'

type OpenAppointment = (event: IPatientSchedule) => void

export type SeriesCardActions = {
  onEditOne: OpenAppointment
  onEditSeries: OpenAppointment
}

// The popover's two buttons: open the visit as is, or ask the dialog to start on the Series tab.
export const seriesCardActions = (open: OpenAppointment): SeriesCardActions => ({
  // A lingering "Edit series" request must never send this opening to the Series tab.
  onEditOne: (event) => {
    clearSeriesTab()
    open(event)
  },
  onEditSeries: (event) => {
    requestSeriesTab(Number(event.id))
    open(event)
  },
})
